// extracted by mini-css-extract-plugin
export var display = "typography-module--display--fd68a";
export var h1 = "typography-module--h1--b701b";
export var h2 = "typography-module--h2--e0647";
export var h3 = "typography-module--h3--38e69";
export var h4 = "typography-module--h4--e2ffa";
export var h5 = "typography-module--h5--26228";
export var h6 = "typography-module--h6--026d8";
export var p = "typography-module--p--c7573";
export var p2xl = "typography-module--p2xl--33f05";
export var pl = "typography-module--pl--07cd9";
export var ps = "typography-module--ps--97a34";
export var pxl = "typography-module--pxl--3a083";
export var stats = "typography-module--stats--a0ef4";
export var tracking = "typography-module--tracking--0e819";